import React, { useState, useEffect } from 'react';
import { makeStyles } from '@material-ui/styles';

import axios from 'axios';
import Header from '../Agent/components/Header/Header';
import SearchBar from '../../components/SearchBar/SearchBar';
import TableList from '../Agent/components/TableList/TableList';
import { get_agent } from '../../api/API';

const useStyles = makeStyles(theme => ({
    root: {
        padding: theme.spacing(3)
    },

    results: {
        marginTop: theme.spacing(3)
    }
}));

// export default function Agent() {

//     const classes = useStyles();

//     const [agents, setAgents] = useState([]);

//     useEffect(() => {
//         let mounted = true;

//         const fetchAgents = () => {
//             axios.get('/api/agents').then(response => {
//                 if (mounted) {
//                     setAgents(response.data.agents);
//                 }
//             });
//         };

//         fetchAgents();

//         return () => {
//             mounted = false;
//         };
//     }, []);

//     const handleFilter = () => {};
//     const handleSearch = () => {};

//     return (
//         <div
//             className={classes.root}
//             title="Agent Details"
//         >
//             <Header />
//             {/* <SearchBar
//                 onSearch={handleSearch}
//             /> */}
//             {agents && (
//                 <TableList
//                 className={classes.results}
//                 agents={agents}
//                 />
//             )}
//         </div>
//     )
// }


export default function Agent(props) {

    const classes = useStyles();

    const [agents, setAgents] = useState([]);
    const fetchAdmins = async () => {
        let data = await get_agent(
            props.match.params.id,
            window.localStorage.getItem("role")
        );
        if (data) {
            setAgents(data);
        }

        // api.get('/get_agents').then( res =>{
        //     console.log(res.data)
        //     setAgents(res.data.data);
        // });
    };
    useEffect(() => {
        let mounted = true;

        console.log(props)

        fetchAdmins();

        return () => {
            mounted = false;
        };
    }, []);

    const refresh = async () => {
        fetchAdmins();

    };
    const handleFilter = () => { };
    const handleSearch = () => { };

    return (
        <div
            className={classes.root}
            title="Admins"
        >
            <Header
                {...props}
                agents={agents}
                agency_id={props.match.params.id}
            />
            {/* <SearchBar
                onSearch={handleSearch}
            /> */}
            {agents && (
                <TableList

                    className={classes.results}
                    agents={agents}
                    refresh={refresh}
                    {...props}
                />
            )}
        </div>
    )
}